/* Rufat Lights redesign 2026 - info pages: turns page / policy HTML into Dcorra-style sections with an "On this page" nav.
   Only restructures markup; the words come unchanged from the page or store policy. */
(function(){
  var SMALL=/^(a|an|and|as|at|but|by|for|in|of|on|or|the|to|vs|via|with|your|our|if|is)$/;
  function titleCase(s){
    var letters=s.replace(/\([^)]*\)/g,'').replace(/[^A-Za-z]/g,'');
    if(letters.length<4||letters!==letters.toUpperCase())return s;
    return s.toLowerCase().replace(/[A-Za-z][^\s\-\/]*/g,function(w,i){return (i>0&&SMALL.test(w))?w:w.charAt(0).toUpperCase()+w.slice(1);})
      .replace(/\(([^)]*)\)/g,function(m,x){return '('+x.toLowerCase()+')';})
      .replace(/\b(ccpa|gdpr|eea|uk|us|usa|eu|sms|mms|faq|faqs|ip|id)\b/gi,function(m){return m.toUpperCase();});
  }
  function clean(t){return (t||'').replace(/\u00a0/g,' ').replace(/\s+/g,' ').trim();}
  function slug(t,used){var s=clean(t).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,48)||'section';var b=s,i=2;while(used[s])s=b+'-'+(i++);used[s]=1;return s;}
  function isEmpty(el){
    if(el.querySelector('img,iframe,video,table,input'))return false;
    return clean(el.textContent)==='';
  }
  function boldLead(p){
    /* <p><strong>Heading</strong><br>text...</p> or <p><strong>Heading</strong></p> -> returns heading text */
    var n=p.firstChild; while(n&&((n.nodeType===3&&clean(n.textContent)==='')||(n.nodeType===1&&/^(META|BR)$/.test(n.tagName))))n=n.nextSibling;
    if(!n||n.nodeType!==1||!/^(STRONG|B)$/.test(n.tagName))return null;
    var t=clean(n.textContent); if(!t||t.length>90)return null;
    var rest=clean(p.textContent).slice(t.length).trim();
    var after=n.nextSibling; while(after&&after.nodeType===3&&clean(after.textContent)==='')after=after.nextSibling;
    if(rest&&!(after&&after.nodeType===1&&after.tagName==='BR'))return null; /* bold words inside a sentence */
    return {el:n,text:t};
  }
  function init(root){
    if(root.dataset.rliInit)return; root.dataset.rliInit='1';
    var src=root.querySelector('[data-rli-src]'); if(!src)return;
    var tc=root.dataset.titlecase==='true', splitBold=root.dataset.splitBold==='true', qa=root.dataset.qa==='true';
    /* tidy */
    src.querySelectorAll('meta,style,script').forEach(function(e){e.remove();});
    src.querySelectorAll('[style]').forEach(function(e){e.removeAttribute('style');});
    src.querySelectorAll('p,div,h1,h2,h3,h4,span').forEach(function(e){ if(e.parentNode&&isEmpty(e)&&!e.querySelector('br~*'))e.remove(); });
    /* one long paragraph with <br><br> breaks -> separate paragraphs */
    src.querySelectorAll('p').forEach(function(p){
      var re=/<br[^>]*>(?:\s|&nbsp;|<span[^>]*>(?:\s|&nbsp;)*<\/span>)*<br[^>]*>/i;
      if(!re.test(p.innerHTML))return;
      p.innerHTML.split(new RegExp(re.source,'gi')).forEach(function(h){ if(clean(h.replace(/<[^>]+>/g,''))==='')return; var n=document.createElement('p'); n.innerHTML=h.replace(/^(\s|&nbsp;|<br[^>]*>)+/i,'').replace(/(\s|&nbsp;|<br[^>]*>)+$/i,''); p.parentNode.insertBefore(n,p); });
      p.remove();
    });
    /* headings: top level -> h2, next level -> h3 */
    var lv=['H1','H2','H3','H4'].filter(function(t){return src.getElementsByTagName(t).length;});
    function retag(el,tag){var n=document.createElement(tag);n.innerHTML=el.innerHTML;el.replaceWith(n);return n;}
    var top=lv[0], sub=lv[1];
    if(top)src.querySelectorAll(top).forEach(function(h){retag(h,'h2');});
    if(sub&&sub!=='H2')src.querySelectorAll(sub).forEach(function(h){retag(h,'h3');});
    if(splitBold){
      var ps=Array.prototype.slice.call(src.querySelectorAll('p'));
      function boldOnly(p){var b=p&&p.tagName==='P'&&boldLead(p);return !!(b&&clean(p.textContent)===b.text);}
      /* consecutive bold-only lines (e.g. a postal address) stay text, wrapped in a box */
      ps.forEach(function(p){
        if(!p.parentNode||!boldOnly(p))return;
        if(!boldOnly(p.nextElementSibling)||boldOnly(p.previousElementSibling))return;
        var box=document.createElement('div'); box.className='rli-addr'; p.parentNode.insertBefore(box,p);
        var n=p; while(boldOnly(n)){var nx=n.nextElementSibling; box.appendChild(n); n=nx;}
      });
      src.querySelectorAll('p').forEach(function(p){
        if(p.closest('.rli-addr'))return;
        var b=boldLead(p); if(!b)return;
        if(qa&&/\?\s*$/.test(b.text))return;
        var h=document.createElement(lv.length?'h3':'h2'); h.textContent=b.text.replace(/[:\s]+$/,'');
        b.el.remove(); var f=p.firstChild; while(f&&((f.nodeType===3&&clean(f.textContent)==='')||(f.nodeType===1&&f.tagName==='BR'))){var x=f.nextSibling;f.remove();f=x;}
        p.parentNode.insertBefore(h,p); if(isEmpty(p))p.remove();
      });
    }
    src.querySelectorAll('h2,h3').forEach(function(h){
      var t=clean(h.textContent).replace(/[:\s]+$/,''); if(!t){h.remove();return;}
      h.textContent=tc?titleCase(t):t;
    });
    /* Q&A accordions: <p><strong>Question?</strong><br>Answer</p> (+ following paragraphs) */
    if(qa){
      Array.prototype.slice.call(src.querySelectorAll('p')).forEach(function(p){
        if(!p.parentNode)return;
        var b=boldLead(p); if(!b||!/\?\s*$/.test(b.text))return;
        var d=document.createElement('details'), s=document.createElement('summary'), a=document.createElement('div');
        a.className='rli-a'; s.textContent=b.text; b.el.remove();
        var f=p.firstChild; while(f&&((f.nodeType===3&&clean(f.textContent)==='')||(f.nodeType===1&&f.tagName==='BR'))){var x=f.nextSibling;f.remove();f=x;}
        p.parentNode.insertBefore(d,p); d.appendChild(s); d.appendChild(a); if(!isEmpty(p))a.appendChild(p); else p.remove();
        var n=d.nextElementSibling;
        while(n&&n.tagName==='P'&&!boldLead(n)){var nx=n.nextElementSibling;a.appendChild(n);n=nx;}
        while(n&&(n.tagName==='UL'||n.tagName==='OL')){var nx2=n.nextElementSibling;a.appendChild(n);n=nx2;}
      });
      /* group consecutive details */
      src.querySelectorAll('details').forEach(function(d){
        var prev=d.previousElementSibling;
        if(prev&&prev.classList.contains('rli-qa'))prev.appendChild(d);
        else{var w=document.createElement('div');w.className='rli-qa';d.parentNode.insertBefore(w,d);w.appendChild(d);}
      });
    }
    /* flatten one wrapper level so headings are direct children */
    if(src.children.length===1&&src.firstElementChild.tagName==='DIV'&&src.querySelector(':scope>div>h2')){var w=src.firstElementChild;while(w.firstChild)src.insertBefore(w.firstChild,w);w.remove();}
    /* wrap into sections */
    var used={}, parts=[], cur=document.createElement('section'); cur.className='rli-part rli-part--intro';
    Array.prototype.slice.call(src.childNodes).forEach(function(n){
      if(n.nodeType===1&&n.tagName==='H2'){
        if(cur.childNodes.length)parts.push(cur);
        cur=document.createElement('section'); cur.className='rli-part'; cur.id=slug(n.textContent,used); cur.setAttribute('data-nav',n.textContent);
      }
      cur.appendChild(n);
    });
    if(cur.childNodes.length)parts.push(cur);
    parts=parts.filter(function(s){return !isEmpty(s);});
    src.innerHTML=''; parts.forEach(function(s){src.appendChild(s);});
    /* nav */
    var nav=root.querySelector('[data-rli-nav]'); if(!nav)return;
    var ol=nav.querySelector('ol'), secs=root.querySelectorAll('.rli-part[data-nav]');
    if(secs.length<2){nav.remove();root.classList.add('rli-body--solo');return;}
    secs.forEach(function(s){var li=document.createElement('li'),a=document.createElement('a');a.href='#'+s.id;a.textContent=s.getAttribute('data-nav');li.appendChild(a);ol.appendChild(li);});
    var mq=matchMedia('(max-width:989px)'); if(mq.matches)nav.open=false;
    nav.querySelector('summary').addEventListener('click',function(e){if(!mq.matches)e.preventDefault();});
    ol.addEventListener('click',function(e){var a=e.target.closest('a');if(!a)return;var t=document.getElementById(a.getAttribute('href').slice(1));if(!t)return;e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});history.replaceState(null,'','#'+t.id);if(mq.matches)nav.open=false;});
    var links=ol.querySelectorAll('a');
    if('IntersectionObserver' in window){
      var vis={};
      var io=new IntersectionObserver(function(es){es.forEach(function(e){vis[e.target.id]=e.isIntersecting;});var on=null;secs.forEach(function(s){if(!on&&vis[s.id])on=s.id;});if(on)links.forEach(function(a){a.classList.toggle('is-active',a.getAttribute('href')==='#'+on);});},{rootMargin:'-120px 0px -55% 0px'});
      secs.forEach(function(s){io.observe(s);});
    }
  }
  function run(){document.querySelectorAll('[data-rli-body]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();
